<template>
  <div id="create-template-modal" class="editor-modal">
    <div class="create">
      <h2>{{ $t("template.cr-tp-title") }}</h2>
      <form @submit="onCreate">
        <div>
          <custom-input
            class="template-name"
            :inputType="'text'"
            v-model="templateName"
            :name="'nameInput'"
            :label="$t('template.cr-tp-name-label')"
            :placeholder="$t('template.cr-tp-name-label')"
            :focusInputField="true"
          />

          <div class="form-group">
            <label :class="{ hidelabel: !language }" for="languageInput">{{ $t("template.cr-tp-lang-label") }}</label>
            <select
              :class="{ empty: !language }"
              class="form-control selector"
              id="languageInput"
              v-model="language"
            >
              <option class="default" :value="null" disabled>
                {{ $t("template.cr-tp-lang-selector") }}
              </option>
              <option v-for="(language, index) in templateLanguages" :key="index" :value="language.value">
                {{ $t(language.name) }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label :class="{ hidelabel: !mainContentSource }" for="contentTypeInput">
              {{ $t("template.cr-tp-integration-label") }}
            </label>
            <select
              :disabled="fetchingContenSources"
              class="form-control selector"
              :class="{ empty: !mainContentSource, 'loading-content': fetchingContenSources }"
              id="contentTypeInput"
              v-model="mainContentSource"
            >
              <option class="default" :value="null" disabled>
                {{ $t("template.cr-tp-integration-selector") }}
              </option>
              <optgroup v-for="(group, index) in optionGroups" :key="index" :label="group.name">
                <option v-for="option in group.options" :key="option.id" :value="option">{{ option.name }}</option>
              </optgroup>
            </select>
            <span v-if="mainContentSource && hasAdditionalDataOptions" class="text-muted text-small supporting-data" @click="showSupportingDataOptions = !showSupportingDataOptions">Add supporting data</span>
          </div>

          <div class="form-group" v-if="showSupportingDataOptions">
            <multi-select
              v-if="availableExtraContentSources.length > 1"
              class="contentsource-multiselect"
              :label="$t('template.cr-tp-data-select')"
              :placeholder="'Select specific integration'"
              :options="contentSourceMultiselectOptions"
              :name="'name'"
              :value="''"
              :fixedMaxHeight="80"
              @value-change="(result) => updateSourceValues(result)"
            />
          </div>

          <div class="form-group">
            <label :class="{ hidelabel: !standardTemplate }" for="standardtemplate">{{$t('template.standard-template')}}</label>
            <select
              :class="{ empty: !standardTemplate }"
              class="form-control selector"
              id="standardtemplate"
              v-model="standardTemplate"
            >
              <option class="default" :value="null" disabled>
                {{$t('template.standard-template')}}
              </option>
              <option
                v-for="(template, index) in availableStandardTemplates"
                :key="index"
                :value="template.templateId"
                v-html="template.name"
              ></option>
            </select>
          </div>
        </div>

        <div class="footer" :class="{ noForm: contentSources == 0 }">
          <button type="submit" class="btn btn-md btn-primary" :disabled=" !valid" @click="onCreate">
            {{ $t("template.cr-tp-btn-create") }}
          </button>
          <button type="reset" class="btn btn-md btn-secondary"  @click="$emit('close')">
            {{ $t("template.cr-tp-btn-cancel") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MultiSelect from "@/components/MultiSelect.vue";
import CustomInput from "@/components/CustomInput";
import Checkbox from "@/components/Checkbox";
import uniqBy from "lodash/uniqBy";
export default {
  props: {
    // contentSources: Array,
    onSave: Function,
    selectedFilter: [Number, String]
  },
  data() {
    return {
      templateName: "",
      contentSource: null,
      contentType: null,
      language: null,
      checkedSources: [],
      standardTemplate: null,
      contentSources: [],
      fetchingContenSources: false,
      optionGroups: [],
      mainContentSource: null,
      showSupportingDataOptions:false,
      // availableStandardTemplates: [],
      allStandardTemplates: [],
      standardTemplateBlackList: ["Demo", "Signup"]
    };
  },
  computed: {
    valid() {
      return this.mainContentSource && this.templateName && this.language      
    },
    availableContentTypes() {
      return uniqBy(this.contentSources.map((cs) => cs.contentType), "id");
    },
    availableExtraContentSources() {
      return this.mainContentSource && this.mainContentSource.contentType ? this.contentSources.filter((cs) => cs.contentType.id === this.mainContentSource.contentType.id) : [] ;
    },

    templateLanguages() {
      return this.$store.state.templateLanguages;
    },

    contentSourceMultiselectOptions() {
      return this.availableExtraContentSources.map((c) => {
        return { label: c.name, value: c.id };
      });
    },

    hasAdditionalDataOptions(){
      return !this.mainContentSource ? [] : this.contentSources.some(c => (c.contentType.id == this.mainContentSource.contentType.id)  && c.id !== this.mainContentSource.id)
    },
    availableStandardTemplates(){
      let languageFiltered =  this.allStandardTemplates.filter(st =>  st.language ? st.language.toLowerCase() == this.language.toLowerCase() : st)
      let typeFiltered = languageFiltered.filter(st => !this.standardTemplateBlackList.includes(st.type))
      return typeFiltered;
    },
    
    selectedContentSources(){
      return [this.mainContentSource].concat(this.checkedSources)
    }
    
  },
  methods: {
    createOptionGroups() {
      this.availableContentTypes.forEach((contentType) => {
        this.optionGroups.push({
          name: contentType.name,
          options: this.contentSources.filter((cs) => cs.contentType.id == contentType.id)
        });
      });
    },

    updateSourceValues(result, id) {
      this.checkedSources = [];
      result.split("||").forEach((id) => {
        this.checkedSources.push(this.availableExtraContentSources.find((c) => id == c.id));
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.onCreate();
    },
    onCreate(evt) {
      evt.preventDefault();
      this.$store
        .dispatch("createTemplate", {
          templateName: this.templateName,
          contentType: this.mainContentSource.contentType,
          contentSource: this.selectedContentSources,
          language: this.language,
          standardTemplateId: this.standardTemplate ? this.standardTemplate : null
        })
        .then((res) => {
          console.log(res)
          this.onSave();
          this.$emit("close");
        });
    }
  },
  created() {
    this.fetchingContenSources = true;
    this.$store
      .dispatch("getContentSources")
      .then((contentSources) => {
        this.contentSources = contentSources;
        this.createOptionGroups();
      })
      .finally(() => {
        this.fetchingContenSources = false;
      });
    
      this.$store.dispatch("getAvailableStandardTemplates").then((res) => {
        this.allStandardTemplates = [{name: this.$t('template.empty-template'), templateId: null}].concat(res.filter(st => st.active))
      })
  },

  watch: {
    language: {
      handler: function() {
        // reset selected standardTemplate if user changes language
        this.standardTemplate = null
      }
    }

  },
  mounted() {
    if (typeof this.selectedFilter == "number") {
      this.contentType = this.availableContentTypes.find((ct) => ct.id == this.selectedFilter);
    }
  },
  components: {
    CustomInput,
    MultiSelect
  }
};
</script>

<style lang="less">
#create-template-modal {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0;
  }

  .template-name {
    margin-bottom: 16px;
  }

  .footer {
    margin-top: 40px;
  }

  .noForm {
    margin-top: 30px;
  }
  .checkboxes {
    display: flex;
    flex-direction: row;
  }
  .hidelabel {
    opacity: 0;
  }
  .supporting-data{
    cursor: pointer;
    text-decoration: underline;
  }
  .contentsource-multiselect {
    margin-top: 32px;
    .top-label {
      font-size: 14px;
    }
  }
}
</style>
